export const CreditCost = {
	Upscale: 3,
	UseOfSwap: 1,
} as const
